import Header from "../components/header/Header";
import MessageModals from "../components/modals/MessageModals";
import DesktopView from "../components/desktopview/DesktopView";
import SupportRequest from "../components/supportrequest/SupportRequest";

import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";

import { BiSupport } from "react-icons/bi";
import { RiMailSendFill } from "react-icons/ri";
import { FaQuoteRight } from "react-icons/fa";
import globalContext from "../Contexts/GlobalContext";

export default function ContactUs() {
  const contextData = useContext(globalContext);
  const [isSupportRequest, setIsSupportRequest] = useState("");
  const navigate = useNavigate();
  return (
    <>
      <div className="hidden min-[1024px]:block ">
        <DesktopView />
      </div>
      <div
        className="relative w-full h-screen flex flex-col items-center justify-between bg-[#153038] min-[1024px]:hidden "
        onClick={() => {
          if (isSupportRequest === "true") {
            setIsSupportRequest("false");
          }
        }}
      >
        <Header relt="relative" />

        <SupportRequest
          setIsSupportRequest={setIsSupportRequest}
          isSupportRequest={isSupportRequest}
        />

        {contextData.isToastOpen && (
          <MessageModals
            setIsOpen={contextData.setIsToastOpen}
            message={contextData.toastMessage}
          />
        )}

        <div
          className={`w-[85vw] h-full flex flex-col items-start justify-start px-[6vw] gap-y-[2vw]`}
        >
          <div className="w-full flex items-center justify-center p-[2vw] my-[12vw]">
            <p className="font-font_primary_A text-[5.5vw] text-white font-bold">
              پشتیبانی
            </p>
          </div>
          <div
            className="w-full h-[12vw] flex items-center justify-start p-[2vw] border-[1px] rounded-[1.8vw] border-color-primary-C gap-x-[4vw]"
            onClick={(e) => {
              e.stopPropagation();
              setIsSupportRequest("true");
            }}
          >
            <RiMailSendFill color="white" size={23} />
            <p className="font-font_primary_A text-[3.5vw] font-light text-white">
              ارسال درخواست پشتیبانی
            </p>
          </div>
          <a href="tel:02177569568" className="w-full">
            <div className="w-full h-[12vw] flex items-center justify-start p-[2vw] border-[1px] rounded-[1.8vw] border-color-primary-C gap-x-[4vw]">
              <BiSupport color="white" size={25} />
              <p className="font-font_primary_A text-[3.5vw] font-light text-white">
                تماس تلفنی
              </p>
            </div>
          </a>
          <div
            className="w-full h-[12vw] flex items-center justify-start p-[2vw] border-[1px] rounded-[1.8vw] border-color-primary-C gap-x-[4vw]"
            onClick={() => {
              navigate("/faq");
            }}
          >
            <FaQuoteRight color="white" size={21} />
            <p className="font-font_primary_A text-[3.5vw] font-light text-white">
              سوالات متداول
            </p>
          </div>
        </div>
        <div className="w-[80vw] h-[35vw] flex items-center px-[4vw]">
          <div className="w-full flex flex-col gap-y-3 items-center justify-center">
            <p className="text-[3vw] text-[#8f8c85] font-font_primary_A font-semibold">
              شبکه‌های اجتماعی اسکارپین
            </p>
            <div className="flex items-center justify-center gap-x-[4vw]">
              <a href="https://eitaa.com/ScarpinChannel" target="_blank">
                <img
                  src="../assets/images/contactus/white_eita.svg"
                  alt=""
                  className="w-[5vw]"
                />
              </a>
              <a href="https://t.me/scarpinChannel" target="_blank">
                <img
                  src="../assets/images/contactus/white_tel.svg"
                  alt=""
                  className="w-[5vw]"
                />
              </a>
              <a
                href="https://instagram.com/scarpin.ir?igshid=YmMyMTA2M2Y"
                target="_blank"
              >
                <img
                  src="../assets/images/contactus/white_insta.svg"
                  alt=""
                  className="w-[5vw]"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
